import { useSignIn } from "@clerk/clerk-react";
import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import Loading from "components/Loading";

const AcceptToken = () => {
  const { signIn, setActive } = useSignIn();

  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();

  const redirectUrl = searchParams.get("redirect");
  const signInToken = searchParams.get("token");

  useEffect(() => {
    if (!signIn || !signInToken) {
      return;
    }

    const createSignIn = async () => {
      setLoading(true);
      try {
        const signInAttempt = await signIn.create({
          strategy: "ticket",
          ticket: signInToken as string,
        });

        if (signInAttempt.status === "complete") {
          setActive({
            session: signInAttempt.createdSessionId,
          });
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    createSignIn();
  }, [signIn, setActive, signInToken]);

  if (!signInToken || !redirectUrl) {
    return <Navigate to="/sign-in" replace />;
  }

  if (loading) {
    return <Loading />;
  }

  return <Navigate to={redirectUrl} replace />;
};

export default AcceptToken;
